// GENERATED by scripts/gen-web-routes.mjs — regenerate after frontend/app/ changes.
import { createFileRoute } from "@tanstack/react-router"
import Page from "@/app/ai-funnel/page"
import { usePageHead } from "../../compat/head"

export const Route = createFileRoute("/ai-funnel/")({
  component: PageComponent,

})

function PageComponent() {
  usePageHead({ title: "AI Funnel" })
  return <Page />
}
